module.exports = __webpack_public_path__ + "img/customer-service.806191e0.png";